import { render, staticRenderFns } from "./xy-page-container.vue?vue&type=template&id=4c1de63a"
import script from "./xy-page-container.vue?vue&type=script&lang=js"
export * from "./xy-page-container.vue?vue&type=script&lang=js"
import style0 from "./xy-page-container.vue?vue&type=style&index=0&id=4c1de63a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports